import * as types from "./faqActionTypes";
import fetchUrl from "../../services/fetchUrl";
import { showSnackBar } from "../../components/Snackbar/snackbarActions";
import makeAjaxRequest from "../../services/makeAjaxRequest";
import { getErrorMessage } from "../../services/utils";

/* Get List of all FAQ */

export const getFaq = () => {
  return dispatch => {
    dispatch(getFaqLoading());
    return makeAjaxRequest({
      method: "GET",
      url: fetchUrl("v2/metadata", "faq"),
      auth: false
    })
      .then(response => {
        let faqData = response.data.data;
        dispatch(getFaqSuccess(faqData));
      })
      .catch(error => {
        let errorMessage = "";
        errorMessage = getErrorMessage(error);
        dispatch(showSnackBar(errorMessage));
        dispatch(getFaqFailure(error));
      });
  };
};

export const getHomePageFaq = () => {
  return dispatch => {
    dispatch(getFaqLoading());
    return makeAjaxRequest({
      method: "GET",
      url: fetchUrl("open", "faqs"),
      auth: false
    })
      .then(response => {
        let faqData = response.data.data;
        dispatch(getFaqSuccess(faqData));
      })
      .catch(error => {
        let errorMessage = "";
        errorMessage = getErrorMessage(error);
        dispatch(showSnackBar(errorMessage));
        dispatch(getFaqFailure(error));
      });
  };
};

export const getFaqLoading = () => {
  return {
    type: types.GET_FAQ_LOADING
  };
};

export const getFaqSuccess = payload => {
  return {
    type: types.GET_FAQ_SUCCESS,
    payload: payload
  };
};

export const getFaqFailure = error => {
  return {
    type: types.GET_FAQ_FAILURE,
    payload: error
  };
};
